import { CategoryState } from '@/redux';
import { ValidationError } from 'yup';
import * as Yup from 'yup';
import { MenuItemCategoryFormValue } from './FormItemMenuItemSuboptions';
import i18next from 'i18next';

export function getCategoriesSchema(categories: CategoryState[]) {
  return Yup.mixed().test(
    'is-valid-categories',
    'Invalid categories structure',
    function (value: Record<string, MenuItemCategoryFormValue>, context) {
      if (typeof value !== 'object' || value === null) {
        return context.createError({
          message: 'Categories must be an object',
          path: context.path,
        });
      }

      const categoryMap = new Map<string, CategoryState>();
      const parentMap = new Map<string, string>();

      categories.forEach((category) => {
        categoryMap.set(category.id, category);
        category.children?.forEach((child) => {
          parentMap.set(child.id, category.id);
          child.children?.forEach((lastChild) => {
            parentMap.set(lastChild.id, child.id);
          });
        });
      });

      for (const [categoryId, category] of Object.entries(value)) {
        if (category.min > category.max) {
          return new ValidationError([
            context.createError({
              path: `${context.path}.${categoryId}.min`,
              message: i18next.t('errors.categories_cannot_be_greater'),
            }),
            context.createError({
              path: `${context.path}.${categoryId}.max`,
              message: i18next.t('errors.categories_cannot_be_less'),
            }),
          ]);
        }
      }

      let errors: ValidationError[] = [];
      for (const [categoryId, category] of Object.entries(value)) {
        const parentId = parentMap.get(categoryId);

        if (parentId) {
          const parent = value[parentId];
          if (!parent) continue;

          if (category.max > parent.max) {
            errors.push(
              context.createError({
                path: `${context.path}.${categoryId}.max`,
                message: i18next.t(
                  'errors.categories_child_cannot_be_greater_parent',
                  {
                    max: category.max,
                    parentMax: parent.max,
                  },
                ),
              }),
            );
          }
        }
      }

      return errors.length > 0 ? new ValidationError([...errors]) : true;
    },
  );
}
